import { observer } from 'mobx-react-lite'
import { DIRTY_LABELS } from 'constants/notes'
import DefaultNotesBlock from '../DefaultNotesBlock'

type NotesBlockProps = {
  // TODO - improve type
  visit: any
  type: 'history' | 'exam' | 'psychotherapy'
}

const NotesBlock = ({ type, visit }: NotesBlockProps) => {
  return (
    <>
      {visit.notes[type]?.description ? (
        <p className="typography-caption text-neutral-500">{DIRTY_LABELS[type] || type} Notes</p>
      ) : null}

      <DefaultNotesBlock type={type} visit={visit} />
    </>
  )
}

export default observer(NotesBlock)
